import AsosList from '../layout/pages/AsosList.vue'
import UploadForm from '../layout/pages/UploadForm.vue'
import { createStore } from 'vuex'
import { markRaw } from 'vue'

export const dataAso = createStore({
  state: () => {
    return {
      pageTitle: 'HOLERITES',
      pageSubTitle: 'Gerencie os documentos dos seus funcionários',

      docs: [], // list
      componentActive: AsosList,
      employees: [], // combo
      afastamento: [], // combo
      form: {
        realizado_em: undefined,
        expired_at: undefined,
        employee: undefined,
        type: '',
        doc: undefined,
        docName: undefined,
        docOriginalName: undefined,
      },
      afastamento_form: {
        employee: undefined,
        realizado_em: undefined,
        expired_at: undefined,
        type: undefined,
        reason: undefined,
        cid: undefined,
        docName: undefined,
        doc: undefined,
      }
    }
  },
  getters: {
    getActiveComponent: (state) => state.componentActive,
    getEmployees: (state) => state.employees,
    getAfastamento: (state) => state.afastamento,
    getDocs: (state) => state.docs,
    getTitle: (state) => state.pageTitle,
    getPageSubTitle: (state) => state.pageSubTitle,
  },
  mutations: {
    RESET_FORM(state) {
      state.form.realizado_em = undefined
      state.form.expired_at = undefined
      state.form.employee = undefined
      state.form.type = ''
      state.form.doc = undefined
      state.form.docName = undefined
      state.form.docOriginalName = undefined
      
      state.afastamento_form.employee = undefined
      state.afastamento_form.realizado_em = undefined
      state.afastamento_form.expired_at = undefined
      state.afastamento_form.type = undefined
      state.afastamento_form.reason = undefined
      state.afastamento_form.cid = undefined
      state.afastamento_form.docName = undefined
      state.afastamento_form.doc = undefined

    },
    SET_FORM_COMPONENT_ACTIVE(state) {
      state.componentActive = markRaw(UploadForm)
    },
    SET_LIST_COMPONENT_ACTIVE(state) {
      state.componentActive = markRaw(AsosList)
    },
    SET_ALL_DOCS(state, value) {
      state.docs = []
      state.docs = value
    },
    SET_EMPLOYEES(state, value) {
      state.employees = value
    },
    SET_AFASTAMENTO(state, value) {
      state.afastamento = value
    },
    SET_PAGE_TITLE(state, value) {
      state.pageTitle = value
    },
    SET_PAGE_SUB_TITLE(state, value) {
      state.pageSubTitle = value
    },
  },
  actions: {
    setPageTitle({ commit }, value) {
      commit('SET_PAGE_TITLE', value)
    },
    setPageSubTitle({ commit }, value) {
      commit('SET_PAGE_SUB_TITLE', value)
    },

    resetForm({ commit }) {
      commit('RESET_FORM')
    },
    setAllDocs({ commit }, val) {
      commit('SET_ALL_DOCS', val)
    },
    setFormComponentActive({ commit }) {
      commit('SET_FORM_COMPONENT_ACTIVE');
    },
    setListComponentActive({ commit }) {
      commit('SET_LIST_COMPONENT_ACTIVE');
    },
    setEmployees({ commit }, value) {
      commit('SET_EMPLOYEES', value)
    },
    setAfastamento({ commit }, value) {
      commit('SET_AFASTAMENTO', value)
    },
  }
})
